import dayjs from 'dayjs';
import { Button, Col, Descriptions, Row, Space } from 'antd';
import styled from 'styled-components';
import { Image } from 'antd';

import { BidPackage } from '../../modules/bid-packages';
import {
  Bidder,
  BidderStatus,
  bidderStatusKorean,
} from '../../modules/bidders';
import { openKisconPage, phoneFormatter } from '../../util/utils';
import BidChanceHistoryListComponent from '../bid-chances/BidChanceHistoryListComponent';
import BidProposalListComponent from '../bid-chances/BidProposalListComponent';
import { styledDescriptions } from '../styled/mixin';
import { useState } from 'react';
import PDFViewModal2 from '../expenses/PDFViewModal2';

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface BidderDetailComponentProps {
  bidder: Bidder;
  bidPackage: BidPackage;
  updateBidderStatus: (status: BidderStatus) => void;
  moveToBidProposalDetailPage: (bidProposalId: number) => void;
  createSubcontract: (bidder: Bidder) => void;
  downloadFile: (attachFileId: string, fileName: string) => void;
  reconfirmBidChance: () => void;
  moveToBidProposalBehalfCreatePage: () => void;
  openSendMessageModal: () => void;
  openBidProposalCreateModal: () => void;
}
function BidderDetailComponent({
  bidder,
  bidPackage,
  updateBidderStatus,
  moveToBidProposalDetailPage,
  createSubcontract,
  downloadFile,
  reconfirmBidChance,
  moveToBidProposalBehalfCreatePage,
  openSendMessageModal,
  openBidProposalCreateModal,
}: BidderDetailComponentProps) {
  const [visible, setVisible] = useState(false);
  const [imageData, setImageData] = useState<any>();
  const [previewFileType, setPreviewFileType] = useState<string>('');

  const openImagePreview = (file: any) => {
    setImageData(file);
    setVisible(true);
    if (file.name.split('.').pop() === 'pdf') {
      setPreviewFileType('pdf');
    } else if (
      file.name.split('.').pop() === 'jpeg' ||
      file.name.split('.').pop() === 'jpg' ||
      file.name.split('.').pop() === 'png'
    ) {
      setPreviewFileType('image');
    } else {
      setPreviewFileType('');
    }
  };

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <h2>
            {bidder.vendor.application.general.name}(
            {bidderStatusKorean[bidder.status]})
          </h2>
        </Col>
        <Col>
          <Space size="small">
            {bidder.status === BidderStatus.SUBMITTED && (
              <Button
                size="small"
                onClick={reconfirmBidChance}
                disabled={dayjs(bidPackage?.bidDueDateTime).isBefore(
                  new Date(),
                )}
              >
                재요청
              </Button>
            )}
            {bidder.status === BidderStatus.AWARDED && (
              <Button
                size="small"
                onClick={() => updateBidderStatus(BidderStatus.NOT_AWARDED)}
              >
                선정취소
              </Button>
            )}
            {bidder.status === BidderStatus.AWARDED && (
              <Button size="small" onClick={openSendMessageModal}>
                결과알림전송
              </Button>
            )}
            {(bidder.status === BidderStatus.SUBMITTED ||
              bidder.status === BidderStatus.NOT_AWARDED) && (
              <Button
                size="small"
                onClick={() => updateBidderStatus(BidderStatus.AWARDED)}
              >
                업체선정
              </Button>
            )}
            {/* {bidder.status === BidderStatus.AWARDED && (
              <Button onClick={() => createSubcontract(bidder)}>
                하도급 계약
              </Button>
            )} */}
          </Space>
        </Col>
      </Row>
      <Row>
        <Col flex={1}>
          <Descriptions
            title="회사정보"
            bordered
            column={2}
            size="middle"
            style={{ marginTop: '30px' }}
            extra={
              <Button
                size="small"
                onClick={() =>
                  openKisconPage(
                    bidder.vendor.application.general.name,
                    bidder.vendor.application.general.representativeName,
                  )
                }
              >
                키스콘 상세정보 열기
              </Button>
            }
          >
            <Descriptions.Item label="업체명">
              <span style={{ marginRight: '10px' }}>
                {bidder.vendor.application.general.name}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label="대표명">
              {bidder.vendor.application.general.representativeName}
            </Descriptions.Item>
            <Descriptions.Item label="사업자등록번호">
              {bidder.vendor.application.general.corporateNumber}
            </Descriptions.Item>
            <Descriptions.Item label="주소">
              {bidder.vendor.application.general.companyAddress}
            </Descriptions.Item>
            <Descriptions.Item label="전화번호">
              {bidder.vendor.application.general.corporatePhoneNumber ===
              undefined
                ? null
                : phoneFormatter(
                    bidder.vendor.application.general.corporatePhoneNumber,
                    1,
                  )}
            </Descriptions.Item>
            <Descriptions.Item label="팩스">
              {bidder.vendor.application.general.companyFaxNumber === undefined
                ? null
                : phoneFormatter(
                    bidder.vendor.application.general.companyFaxNumber,
                    1,
                  )}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Descriptions
        title="담당자 정보"
        bordered
        column={3}
        size="middle"
        style={{ marginTop: '30px' }}
      >
        <Descriptions.Item label="이름">
          {bidder.vendor.application.contactPoint.name}
        </Descriptions.Item>
        {/* <Descriptions.Item label="회사전화번호">
          {bidder.vendor.application.contactPoint.corporatePhoneNumber ===
          undefined
            ? null
            : phoneFormatter(
                bidder.vendor.application.contactPoint.corporatePhoneNumber,
                1,
              )}
        </Descriptions.Item> */}
        <Descriptions.Item label="휴대전화번호">
          {bidder.vendor.application.contactPoint.personalPhoneNumber ===
          undefined
            ? null
            : phoneFormatter(
                bidder.vendor.application.contactPoint.personalPhoneNumber,
                1,
              )}
        </Descriptions.Item>
        <Descriptions.Item label="이메일">
          {phoneFormatter(bidder.vendor.application.contactPoint.email, 1)}
        </Descriptions.Item>
      </Descriptions>
      {bidder.bidChance &&
        (bidder.status === BidderStatus.ACCEPTED ||
          bidder.status === BidderStatus.SUBMITTED ||
          bidder.status === BidderStatus.NOT_AWARDED ||
          bidder.status === BidderStatus.RECONFIRM ||
          bidder.status === BidderStatus.AWARDED) && (
          <Row style={{ marginTop: '30px' }}>
            <Col flex={1}>
              <BidProposalListComponent
                isSovIncluded={bidPackage.isSovIncluded}
                // bidProposals={bidder.bidChance?.bidProposals}
                bidder={bidder}
                moveToBidProposalDetailPage={moveToBidProposalDetailPage}
                downloadFile={downloadFile}
                openBidProposalCreateModal={openBidProposalCreateModal}
                openImagePreview={openImagePreview}
              />
            </Col>
          </Row>
        )}
      {bidder.bidChance && bidder.bidChance.bidChanceHistories.length > 0 && (
        <Row style={{ marginTop: '30px' }}>
          <Col flex={1}>
            <BidChanceHistoryListComponent
              bidChanceHistories={bidder.bidChance?.bidChanceHistories}
            />
          </Col>
        </Row>
      )}
      {imageData && previewFileType === 'image' && (
        <Image
          width={200}
          style={{ display: 'none' }}
          preview={{
            visible,
            src: imageData?.url,
            onVisibleChange: (value) => {
              setVisible(value);
              setImageData(null);
              setPreviewFileType('');
            },
          }}
        />
      )}
      {imageData && previewFileType === 'pdf' && (
        <PDFViewModal2
          visible={!!imageData}
          url={imageData.url}
          onCancel={() => {
            setImageData(null);
            setPreviewFileType('');
          }}
          onDownload={() => downloadFile(imageData.id, imageData.name)}
        />
      )}
    </StyledDiv>
  );
}

export default BidderDetailComponent;
